<h3 class="submenu_heading">Booking</h3>
<ul class="navGroups">		
	<li><a [routerLink]="['/']">Sub menu 1</a></li>			
	<li><a [routerLink]="['/']">Sub menu 2</a></li>			
	<li><a [routerLink]="['/']">Sub menu 3</a></li>			
	<li><a [routerLink]="['/']">Sub menu 4</a></li>			
</ul>